module.exports = __webpack_public_path__ + "img/KFK_LOGO.59a88f69.png";